export default __webpack_public_path__ + "static/media/side.44928baf.png";